import React, { useEffect, useState } from "react";

import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";

import { IngredientsList } from "api/models";
import { resources } from "api/resources";
import { useQuery } from "api/useQuery";
import {
  BorderBox,
  Header2,
  Layout,
  PageLoadStateProvider
} from "components/common";
import { TranslationProvider } from "components/useTranslations";

import IngredientsAdditionButton from "./IngredientsAdditionButton";
import IngredientsTable from "./IngredientsTable";
import useIngredientsPageStyles from "./useIngredientsPageStyles";

const IngredientsPage: React.FC = () => {
  const [selectedVersion, setSelectedVersion] = useState<string | null>(null);

  const versionedResource = resources.ingredients(selectedVersion ?? undefined);

  const { data: response, isLoading: ingredientsLoading } =
    useQuery<IngredientsList>(versionedResource);

  const styles = useIngredientsPageStyles();

  useEffect(() => {
    if (response?.translations && !selectedVersion) {
      const defaultVersion =
        response.translations[
          // eslint-disable-next-line @typescript-eslint/dot-notation
          "__INGREDIENTS_INITIAL_VIEW_ALL_INGREDIENTS_CNS_VERSION"
        ];
      if (defaultVersion) setSelectedVersion(defaultVersion);
    }
  }, [response?.translations, selectedVersion]);

  return (
    <PageLoadStateProvider isLoaded={!!response?.translations}>
      <TranslationProvider translations={response?.translations}>
        {t => (
          <BorderBox width="full" height="full">
            <Layout layoutStyle="page">
              <Grid container>
                <Grid size={{ xs: 12 }}>
                  <div className={styles.headerStyling}>
                    <Header2>{t`__INGREDIENTS_INITIAL_VIEW_TITLE`}</Header2>
                    <IngredientsAdditionButton />
                  </div>
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <FormControl
                    variant="outlined"
                    size="small"
                    style={{ minWidth: 200, marginBottom: 16 }}
                  >
                    <InputLabel id="cns-version-label">
                      {t`__INGREDIENTS_INITIAL_VIEW_CNS_VERSION_DROPDOWN_DEFAUL`}
                    </InputLabel>
                    <Select
                      label={t`__INGREDIENTS_INITIAL_VIEW_CNS_VERSION_DROPDOWN_DEFAUL`}
                      labelId="cns-version-label"
                      value={
                        selectedVersion ??
                        t`__INGREDIENTS_INITIAL_VIEW_ALL_INGREDIENTS_CNS_VERSION`
                      }
                      onChange={e => setSelectedVersion(e.target.value)}
                    >
                      {response?.cnsVersionOptions?.map(option => (
                        <MenuItem
                          key={option.keyValue}
                          value={option.displayValue}
                        >
                          {option.displayValue}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <IngredientsTable
                    ingredients={response?.ingredients ?? []}
                    ingredientsLoading={ingredientsLoading}
                  />
                </Grid>
              </Grid>
            </Layout>
          </BorderBox>
        )}
      </TranslationProvider>
    </PageLoadStateProvider>
  );
};

export default IngredientsPage;
